import React, { useState, useCallback, useEffect } from "react";
import { officeApi } from "../api/config";
import { GetUser } from "../api/userapi";
import { PgInter, UserCardState } from "../interface/interface";

type ReturnType = [
  undefined | Array<UserCardState>,
  (filter: UsrFilterType) => void,
  (usr_id: string) => void,
  (usr_id: string) => void,
  (usr_id: string) => void,
  () => void
];

export type UsrFilterType = {
  isMarketing?: boolean;
  isProject?: boolean;
  isLeader?: boolean;
  text?: string;
};

/** 유저 데이터 관련 hooks */
const UseUserData = ({ limit }: { limit: number }): ReturnType => {
  const [data, setData] = useState<undefined | Array<UserCardState>>(undefined);
  const [pg, setPg] = useState<PgInter>({
    page_cur: 1,
    page_last: 1,
    page_next: 1,
  });
  const [isMarketing, setIsMarketing] = useState<boolean | undefined>(
    undefined
  );
  const [isProject, setIsProject] = useState<boolean | undefined>(undefined);
  const [isLeader, setIsLeader] = useState<boolean | undefined>(undefined);
  const [text, setText] = useState<string>("");
  const LeaderInsert = useCallback((usr_id: string) => {
    officeApi
      .post(`/auth/usr/USR_GRP_STTS_READ/${usr_id}`, {})
      .then((result) => {
        // console.log(result);
      });
  }, []);

  const LeaderDelete = useCallback((usr_id: string) => {
    officeApi.delete(`/auth/usr/USR_GRP_STTS_READ/${usr_id}`).then((result) => {
      // console.log(result);
    });
  }, []);

  const GetDefaultUser = useCallback(
    (page: number) => {
      let obj: {
        login_id: string;
        agr_adv?: number;
        leader?: boolean;
        isProject?: number;
      } = {
        login_id: text,
      };
      if (isMarketing !== undefined) {
        obj.agr_adv = isMarketing ? 1 : 0;
      }
      if (isProject !== undefined) {
        obj.isProject = isProject ? 1 : 0;
      }
      if (isLeader) {
        obj.leader = true;
      }

      GetUser(obj, page, limit).then(({ state, data }) => {
        if (state) {
          setPg(data?.pg);
          setData(data?.lst);
        }
      });
    },
    [limit, isMarketing, isLeader, isProject, text]
  );
  const PagingUpdate = useCallback(() => {
    let obj: {
      login_id: string;
      agr_adv?: number;
      leader?: boolean;
      isProject?: number;
    } = {
      login_id: text,
    };
    if (isMarketing !== undefined) {
      obj.agr_adv = isMarketing ? 1 : 0;
    }
    if (isProject !== undefined) {
      obj.isProject = isProject ? 1 : 0;
    }
    if (isLeader) {
      obj.leader = true;
    }
    if (pg) {
      const { page_next, page_last, page_cur } = pg;
      if (page_cur < page_last) {
        GetUser(obj, page_next, limit).then(({ state, data: userData }) => {
          if (state && userData) {
            setPg(userData.pg);
            let clone = data ? data.slice() : [];
            clone = [...clone, ...userData.lst];
            setData(clone);
          }
        });
      }
    }
  }, [
    pg,
    isMarketing,
    isLeader,
    text,
    data,
    limit,
    isMarketing,
    isLeader,
    isProject,
  ]);
  const RemoveUsers = useCallback(
    (usr_id: string) => {
      officeApi
        .delete(`/auth/usr/usr/${usr_id}`)
        .then(({ data: { sts_fg } }) => {
          if (sts_fg) {
            GetDefaultUser(pg.page_cur);
          }
        });
    },
    [GetDefaultUser, pg]
  );
  const SearchUser = useCallback(
    ({ isMarketing, isProject, isLeader, text }: UsrFilterType) => {
      setIsMarketing(isMarketing);
      setIsProject(isProject);

      if (isLeader !== undefined) {
        setIsLeader(isLeader);
      }
      if (text !== undefined) {
        setText(text);
      }
    },
    [GetDefaultUser]
  );
  useEffect(() => {
    GetDefaultUser(1);
    return () => {};
  }, [isMarketing, isLeader, isProject, text]);

  useEffect(() => {
    GetDefaultUser(1);
    return () => {};
  }, [GetDefaultUser]);
  return [
    data,
    SearchUser,
    LeaderInsert,
    LeaderDelete,
    RemoveUsers,
    PagingUpdate,
  ];
};

export default UseUserData;
